export default [
  {
    name: 'default_project_template',
    path: 'modules/templates/TemplateLayout'
  }
]
